// components/SelectedMenuItem/SelectedMenuItem.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

// CSS
import "./selected-menu-item.css";

// Context
import { useCart } from "../../context/CartContext";

// Icons
import { FaMinus, FaPlus } from "react-icons/fa";

const SelectedMenuItem = ({ menuItem, closeModal }) => {
  const { cart, setCart } = useCart();
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    const cartItem = cart.find((item) => item._id === menuItem?._id);
    if (cartItem) {
      setQuantity(cartItem.quantity);
    }
  }, [menuItem, cart]);

  // 🔥 FIRE VIEWCONTENT EVENT WHEN MODAL OPENS
  useEffect(() => {
    if (menuItem && window.fbq) {
      window.fbq("track", "ViewContent", {
        content_ids: [menuItem._id],
        content_name: menuItem.title,
        content_category: menuItem.category?.[0] || "General",
        content_type: "product",
        value: menuItem.price,
        currency: "BDT",
        // Optional: Add description for better insights
        content_description: menuItem.desc?.substring(0, 100),
      });

      console.log("👁️ ViewContent event fired for:", menuItem.title);
    }
  }, [menuItem]);

  const increaseQuantity = () => setQuantity(quantity + 1);
  const decreaseQuantity = () => setQuantity(quantity > 1 ? quantity - 1 : 1);

  const handleAddToCart = () => {
    const updatedCart = [...cart];
    const existingItemIndex = updatedCart.findIndex(
      (item) => item._id === menuItem._id,
    );

    if (existingItemIndex !== -1) {
      updatedCart[existingItemIndex].quantity = quantity;
    } else {
      updatedCart.push({ ...menuItem, quantity });
    }
    toast("Item added to cart!");
    setCart(updatedCart);

    // 🔥 Optional: Track AddToCart event too (good for funnel analysis)
    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        content_ids: [menuItem._id],
        content_name: menuItem.title,
        content_type: "product",
        value: menuItem.price * quantity,
        currency: "BDT",
      });
      console.log("🛒 AddToCart event fired for:", menuItem.title);
    }
  };

  return (
    <div className="selected-menu-item">
      <div className="selected-menu-item-container">
        <img
          src={menuItem.imageUrl[0]}
          alt={menuItem.title}
          className="selected-menu-item-img"
        />

        <div className="selected-menu-item-details">
          <h2 className="selected-menu-item-title">{menuItem.title}</h2>
          <p className="selected-menu-item-price">Price: ৳{menuItem.price}</p>

          <div className="selected-menu-item-quantity-container">
            <FaMinus className="quantity-minus" onClick={decreaseQuantity} />
            <input
              type="number"
              className="selected-menu-item-quantity"
              value={quantity}
              min="1"
              onChange={(e) => {
                let value = parseInt(e.target.value, 10);
                if (isNaN(value) || value < 1) value = 1;
                setQuantity(value);
              }}
            />
            <FaPlus className="quantity-plus" onClick={increaseQuantity} />
          </div>

          <p className="selected-menu-item-total">
            <span>Total:</span>
            <span className="total">৳{menuItem.price * quantity}</span>
          </p>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />

          <div className="selected-menu-item-btns">
            <button
              onClick={handleAddToCart}
              className="add-to-cart-btn btn btn-primary"
            >
              Add to Cart
            </button>
            <Link to="/order" className="view-order-btn btn btn-secondary">
              View Order
            </Link>
            <button onClick={closeModal} className="btn btn-back">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedMenuItem;
